/* eslint-disable react/prop-types */
import React from 'react';

import { getSite, isAntena3, isLaSexta } from 'constants/sites';
import './tooltip.scss';
import Caret from 'components/caret';

const customAcronym = (partyFormat, site) => {
  if (isLaSexta(site)) {
    return partyFormat.laSextaAcronym || partyFormat.partyAcronym;
  }
  if (isAntena3(site)) {
    return partyFormat.a3Acronym || partyFormat.partyAcronym;
  }
  return partyFormat.partyAcronym;
};
const customColor = (partyFormat, site) => {
  if (isLaSexta(site)) {
    return partyFormat.laSextaColor || partyFormat.partyColor;
  }
  if (isAntena3(site)) {
    return partyFormat.a3Color || partyFormat.partyColor;
  }
  return partyFormat.partyColor;
};
const site = getSite();

const Tooltip = ({ mousePos, selectedItem, data }) => (
  <div
    className="mapTooltip"
    style={{
      position: 'fixed',
      left: mousePos.x + 15,
      top: mousePos.y - 5
    }}
  >
    <span className="mapTooltip-title">{selectedItem.name || '-'}</span>
    <ul className="mapTooltip-list">
      {data && data.length ? (
        data
          .filter(p => p.seats > 0)
          .map(item => (
            <li className="mapTooltip-item" key={customAcronym(item, site)}>
              <span className="mapTooltip-party">
                <span
                  className="mapTooltip-colorParty"
                  style={{ backgroundColor: customColor(item, site) }}
                />
                {customAcronym(item, site)}
              </span>
              <span className="mapTooltip-seats">{item.seats}</span>
              {!item.nodata ? (
                <Caret difference={item.difference} nodata={item.nodata} />
              ) : (
                <span className="Caret dato-wrapper" />
              )}
            </li>
          ))
      ) : (
        <></>
      )}
    </ul>
  </div>
);

export default Tooltip;
